import { api } from "api/apiService";

/**
 * Завантажує список рекомендацій з урахуванням параметрів фільтрації.
 * @param {object} [filters={}] - Об'єкт з параметрами для фільтрації.
 * @returns {Promise<object>} Проміс, що повертає об'єкт з даними про рекомендації.
 */
export const fetchRecommendations = (filters) => {
  // Копіюємо лише ті фільтри, які мають реальне значення
  const cleanFilters = {};
  for (const key in filters) {
    const value = filters[key];
    if (value !== null && value !== undefined && value !== "") {
      cleanFilters[key] = value;
    }
  }

  return api.get("/recommendation", cleanFilters);
};

/**
 * Функція для оновлення рекомендації
 * @param {string} warehouse_id - ідентифікатор складу
 * @param {string} article - артикул товару
 * @param {object} data - дані про рекомендацію
 */
export const upsertRecommendation = (warehouse_id, article, data) => {
  const url = `/recommendation/${warehouse_id}/${encodeURIComponent(article)}`;
  return api.put(url, data);
};

/**
 * Функція для видалення рекомендації
 * @param {string} warehouse_id - ідентифікатор складу
 * @param {string} article - артикул товару
 */
export const deleteRecommendation = (warehouse_id, article) => {
  const url = `/recommendation/${warehouse_id}/${encodeURIComponent(article)}`;
  return api.delete(url);
};

/**
 * Функція для збереження індивідуальних оптових націнок товару
 * @param {string} article - артикул товару
 * @param {object} markups - націнки { markup_1, markup_5, markup_10 }, null — стандартна
 */
export const upsertWholesaleMarkups = (article, markups) => {
  const url = `/recommendation/wholesale-markups/${encodeURIComponent(article)}`;
  return api.put(url, markups);
};

/**
 * Функція для оновлення коментаря до рекомендації
 * @param {string} warehouse_id - ідентифікатор складу
 * @param {string} article - артикул товару
 * @param {string} comment - коментар
 */
export const upsertComment = (warehouse_id, article, comment) => {
  const url = `/recommendation/${warehouse_id}/${encodeURIComponent(article)}/comment`;
  return api.put(url, { comment });
};
